export const searchUnits = {
  "* Touch the clinic's name on the map to see the details":
    '* Toque no nome da clínica no mapa para ver os detalhes',
  'Activate location': 'Ativar localização',
  'Activate the location to find the ideal clinic more quickly':
    'Ative a localização para encontrar a clínica ideal mais rapidamente',
  City: 'Cidade',
  'Find a Clinic': 'Encontre uma Clínica',
  'Find clinics': 'Encontrar unidades',
  'Find the ideal clinic to start living without hair':
    'Encontre a clínica ideal para começar a viver a vida sem pelinhos',
  'Find the nearest clinic': 'Encontre a clínica mais próxima de você',
  Select: 'Selecione',
  'Select the state and the city to find the ideal Vialaser unit for you':
    'Selecione o estado e a cidade para encontrar a unidade Vialaser ideal para você',
  State: 'Estado',
  'Find the nearest unit': 'Encontre uma Unidade Vialaser Perto de Você',
  'Find the nearest Vialaser location and visit our clinic. Laser hair removal with advanced technology and specialized service.':
    'Encontre a unidade Vialaser mais próxima e visite nossa clínica. Depilação a laser com tecnologia avançada e atendimento especializado.',
  'Vialaser units, laser hair removal near me, hair removal clinic':
    'Unidades vialaser, depilação a laser perto de mim, clínica depilação',
  'Laser hair removal': 'Depilação a laser',
};
